import { useAuth, useSubscription } from '@chainlit/react-client';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@/components/i18n/Translator';

interface MessageLimitProps {
  context?: 'welcome' | 'footer';
}

const LockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="inline mr-1.5 shrink-0" style={{ verticalAlign: '-2px' }}>
    <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default function MessageLimit({ context = 'welcome' }: MessageLimitProps) {
  const { isProUser } = useSubscription();
  const { user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isAdmin = user?.metadata?.role === 'ADMIN';

  if (isAdmin || isProUser) return null;

  const handleUpgrade = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate('/dashboard#upgrade');
  };

  return (
    <div className={`w-full flex justify-center ${context === 'footer' ? 'mb-1' : 'mb-0'}`}>
      <div className="w-full max-w-2xl rounded-2xl border border-gray-700 bg-black dark:bg-black px-4 py-3 text-center text-sm font-bold flex items-center justify-center gap-3 flex-wrap">
        <span className="text-white">
          <LockIcon />
          {t('upgradeBanner.message')}
        </span>
        <button
          onClick={handleUpgrade}
          className="inline-flex items-center px-3 py-1 rounded-lg border border-gray-500 hover:border-white text-white text-xs font-semibold transition-colors hover:bg-gray-800"
        >
          {t('upgradeBanner.upgradeNow')}
        </button>
      </div>
    </div>
  );
}
